import axios from 'axios';
import { urlApi } from 'config'

const checkHttpStatus = code => code >= 200 && code < 300;

export default function api () {
	let headers = {
			'Content-Type': 'application/json'
		},
		instance = axios.create({
			baseURL: urlApi,
			//headers,
			validateStatus: checkHttpStatus
		})

	instance.interceptors.response.use(function (response) {
		return response;
	}, function (error) {
		if (error.response.status == 422) {
				throw error.response.data
		}else{
				alert('Błąd serwera, proszę spróbować ponownie');
		}

		return Promise.reject(error);
	});

	return instance;
}
